import { createTrackingEvent } from '@/common/analytics/gtm/createTrackingEvent';
import { mapMessageToEventItem } from '@/common/analytics/gtm/mappers';
import { EventMessage } from '@/common/analytics/gtm/types';

export const trackGA4SelectItem = (message: EventMessage) => {
  if (message.metadata.messageSendingDisabled) return;
  createTrackingEvent({
    event: 'sst_select_item',
    ecommerce: {
      items: [mapMessageToEventItem(message)],
    },
  });
};
